

export interface CSVHeaders {
    [key: string]: (root: any) => any
}

export interface CSVEntries {
    [email: string]: any[]
}

export function importCSVFile(data: string[][]): CSVEntries {
    let out: CSVEntries = {};

    const headers = data.splice(0, 1)[0].map((field: string, index: number) => {
        if(field === 'email') {
            return (val: any, raw: string): any[] => {
                return [val, raw]
            }
        }
        return (val: any, raw: string): any[] => {
            let cache = val;
            let temp = field.split('.');
            temp.forEach((part: string, index_part: number) => {
                if(index_part === temp.length - 1) {
                    if(Number.isNaN(parseInt(part))) {
                        cache[part] = raw
                    } else {
                        cache.splice(parseInt(part), 0, raw)
                    }
                } else {
                    if(Number.isNaN(parseInt(part))) {
                        if(!cache[part]) {
                            cache[part] = {};
                        }
                    } else {
                        if(!cache[parseInt(part)]) {
                            cache[parseInt(part)] = {};
                        }
                    }
                    cache = cache[part];
                }
            })
            return [val, ""];
        }
    })
    data.forEach((values: string[]) => {
        let email = '';
        let subject: any = {}
        headers.forEach((header, index: number) => {
            let tempEmail: string
            [subject, tempEmail] = header(subject, values[index])
            if(tempEmail !== "") {
                email = tempEmail
            }
        })
        if(out[email] && out[email].length !== 0) {
            out[email].push(subject)
        } else {
            out[email] = [subject]
        }
    })
    return out
}

export function createCSVFile(header: CSVHeaders, values:CSVEntries): string {
    let temp = Object.keys(header).filter(field => field !== 'email');
    temp = ["email", ...temp]
    return temp.join(",") + "\n" + Object.keys(values).map((email) => {
        return temp.map((field: string) => {
            if(field === 'email') {
                return email
            }
            return header[field](values[email]) as string
        }).join(",")
    }).join("\n")
}

export function csvHeaders(email: string, value: any): CSVHeaders {
    let out: CSVHeaders = {
        "email": (root: any): any => {
            return email
        }
    };
    _csvHeaderRecursion(value, "", (name: string, value: (root: any) => any) => {
        out[name] = value
    })
    return out
}

function _csvHeaderRecursion(value: any, name: string, cb: (name: string, value: (root: any) => any) => void, parser?: (root: any) => any) {
    if(typeof value === 'string') {
        cb(name, (root: any): any => {
            if(parser) {
                return parser(root)
            }
            return root
        })
        return 
    }
    if(Array.isArray(value)) {
        value.forEach((field: any, index: number) => {
            _csvHeaderRecursion(field, (name !== '') ? name+"."+index : index + "", cb, (root: any): any => {
                let out = root;
                if(parser) {
                    out = parser(root);
                }
                return out[index];
            })
        })
        return 
    }
    if(typeof value === 'object') {
        Object.keys(value).forEach((field) => {
            _csvHeaderRecursion(value[field], (name !== '') ? name+"."+field : field, cb, (root: any): any => {
                let out = root;
                if(parser) {
                    out = parser(root);
                }
                return out[field];
            })
        })
        return 
    }
}